import axios from 'axios';
import { DateTime } from 'luxon';

export const createBooking = (type) => {
    return axios.post(`/mapi/bookings`, { type });
};

export const updateBooking = ({
    uid,
    locationId,
    practitionerId,
    dateRangeStart,
    dateRangeEnd,
    newPatient,
    weekday
}) => {
    return axios.patch(`/mapi/bookings/${uid}`, {
        uid,
        locationId,
        practitionerId,
        newPatient,
        appointmentRangeDay: weekday,
        appointmentRangeStartDate: dateRangeStart,
        appointmentRangeEndDate: dateRangeEnd
    });
};

export const holdBooking = ({ appointmentId, uid }) => {
    return axios.patch(`/mapi/bookings/${uid}/hold`, {
        appointmentId
    });
};

export const releaseBooking = ({ appointmentId, uid }) => {
    return axios.patch(`/mapi/bookings/${uid}/release`, {
        appointmentId
    });
};

export const getBooking = ({ uid }) => {
    return axios.get(`/mapi/bookings/${uid}`);
};

export const completeBooking = ({ uid, details }) => {
    const DateOfBirth = DateTime.fromFormat(details.dob, 'dd/M/yyyy').toFormat('yyyy-MM-dd');

    return axios.patch(`/mapi/bookings/${uid}/book`, {
        MemberNumber: details.membershipNumber,
        DependentCode: details.hicapsCode,
        DateOfBirth,
        firstName: details.firstName,
        surname: details.lastName,
        phoneNumber: details.phoneNumber
    });
};

export const checkStatus = () => {
    return axios.get(`/mapi/bookings?type=optical`);
};

export const validateDetails = ({ uid, details }) => {
    const DateOfBirth = DateTime.fromFormat(details.dob, 'dd/M/yyyy').toFormat('yyyy-MM-dd');

    return axios.patch(`/mapi/bookings/${uid}/patient`, {
        MemberNumber: details.membershipNumber,
        DependentCode: details.hicapsCode,
        DateOfBirth,
        firstName: details.firstName,
        surname: details.lastName,
        phoneNumber: details.phoneNumber
    });
};

export const removePatient = ({ uid }) => {
    return axios.patch(`/mapi/bookings/${uid}/remove-patient`);
};

export const getUi = () => {
    return axios.get(`/marketing-api/online-booking/ui.json`).then((res) => res.data);
};

export const expire = ({ uid }) => {
    return axios.patch(`/mapi/bookings/${uid}/expire`);
};
